// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3t2ho","text":"SelectPayment_text__2fVSf","title":"SelectPayment_title__2HkdG","btn":"SelectPayment_btn__1VgRb"};